import { DOGOLAND_LOGO } from "../assets";
import { t } from "../i18n";

/* themed suspense fallback shown while a lazily loaded page or panel arrives */
export default function Loader({ full = true, label }) {
  return (
    <div className={`${full ? "min-h-screen" : "min-h-[40vh]"} flex flex-col items-center justify-center gap-4 bg-[#0B0B0F] text-amber-200`} data-testid="lazy-loader">
      <img src={DOGOLAND_LOGO} alt="" className="h-14 w-14 object-contain drop-shadow-[0_0_18px_rgba(220,38,38,0.6)] animate-pulse" />
      <span className="font-cinzel tracking-[0.35em] text-xs sm:text-sm uppercase rune-pulse">{label || t("app.loading")}</span>
    </div>
  );
}
